import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../features/authSlice';
import { isTokenExpired, getTokenExpirationTime } from '../utils/jwtUtils';

/**
 * Hook to monitor token expiration and auto-logout when expired
 * Checks every 30 seconds or when token changes
 */
export const useTokenExpiration = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);

  useEffect(() => {
    if (!token) return;

    // Check immediately
    if (isTokenExpired(token)) {
      dispatch(logout());
      window.location.href = '/login';
      return;
    }

    // Set up periodic checking
    const checkInterval = setInterval(() => {
      if (isTokenExpired(token)) {
        dispatch(logout());
        window.location.href = '/login';
      }
    }, 30000); // Check every 30 seconds

    // Also set a timeout to logout exactly when token expires
    const expirationTime = getTokenExpirationTime(token);
    let expirationTimeout;
    
    if (expirationTime > 0 && expirationTime < 24 * 60 * 60 * 1000) { // Less than 24 hours
      expirationTimeout = setTimeout(() => {
        dispatch(logout());
        window.location.href = '/login';
      }, expirationTime);
    }

    return () => {
      clearInterval(checkInterval);
      if (expirationTimeout) {
        clearTimeout(expirationTimeout);
      }
    };
  }, [token, dispatch]);
};
